import apiClient from '@/plugins/axios';

export default {
	getApiKeys(params) {
		return apiClient.get(
			`/v1/CustomerApiKey?CustomerId=${params.customerId}&Name=${params.name}&PageNumber=${params.currentPage}&PageSize=${params.pageSize}`
		);
	},

	createApiKey(body) {
		return apiClient.post('/v1/CustomerApiKey', body);
	},

	deleteApiKey(key) {
		return apiClient.delete(`/v1/CustomerApiKey/${key}`);
	}
};
